/**
 * api 上传接口
 */
import { post } from '@/utils/http'

// base64 图片上传
export const apiUploadByBase64 = p => post('/upload/uploadByBase64.do', p)
